import React from 'react';
import { Button } from 'antd';
import Cropper from "react-easy-crop";
import './ImageCropper.css';

const ImageCropper = ({ 
  imageUrl, 
  crop, 
  zoom, 
  aspect, 
  onCropChange, 
  onZoomChange, 
  onCropComplete, 
  onClose, 
  onCrop 
}) => {
  return (
    <div className="cropper-overlay">
      <div className="cropper-modal">
        <div className="cropper-header">
          <h3 className="cropper-title">Crop Image</h3>
          <Button 
            icon={<span>&times;</span>}
            onClick={onClose}
            className="close-button"
          />
        </div>
        <div className="cropper-container">
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="zoom-control">
          <span>Zoom: </span>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            className='text-red-500'
            onChange={(e) => onZoomChange(parseFloat(e.target.value))}
          />
        </div>
        <div className="cropper-controls">
          <Button
            onClick={onCrop}
            className="px-4 py-1 h-[28px] flex items-center justify-center btn-primary hover:border-[#E5383B]"
          >
            Crop Image
          </Button>
          <Button
            onClick={onClose}
              className="px-4 py-1 h-[28px] flex items-center justify-center btn-tertiary"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;